/* eslint-disable operator-linebreak */
import React from 'react';
import { FormApi } from 'final-form';
import Input, { Select, SelectItem, InputWithSelect, SelectInnerItem, AmountInput } from 'ui/Input';
import { onlyNCharacters, onlyNumbers } from 'utils/formatters';
import { IAccount } from 'store/accounts.model';
import { ICardsState, IFormValues, IHandleFieldsChange } from './SingleCardLoad.model';

type FormType = FormApi<IFormValues, Partial<IFormValues>>;

const renderSourceAccountField = (accounts: IAccount[], submitting: boolean) => (
  <Select name="accountNumber" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

export const renderCustomerIdField = (
  values: IFormValues,
  beneficiaries: ICardsState['beneficiaries'],
  form: FormType,
  submitting: boolean,
  handleFieldsChange: IHandleFieldsChange,
) => {
  const { customerId } = values;
  const savedBeneficiary =
    customerId?.length > 5 ? beneficiaries.find(({ cardCustomerId }) => cardCustomerId === customerId) : undefined;

  const onClick = () => form?.change('customerId', '');
  const handleBlur = () => {
    handleFieldsChange();
  };

  return (
    <InputWithSelect
      name="customerId"
      label="Customer ID"
      fieldProps={{
        parse: (value: string) => onlyNCharacters(10)(onlyNumbers(value)),
      }}
      isEmpty={!customerId}
      showMessage={savedBeneficiary !== undefined}
      message={savedBeneficiary?.name}
      onClear={onClick}
      disabled={submitting}
      onBlur={handleBlur}
    >
      {beneficiaries.map(({ cardCustomerId, name }) => (
        <SelectItem value={cardCustomerId} key={cardCustomerId}>
          <SelectInnerItem label={name} value={cardCustomerId} />
        </SelectItem>
      ))}
    </InputWithSelect>
  );
};

export const renderCardsLastFourDigitsField = (submitting: boolean) => (
  <Input
    name="last4Digit"
    label="Card's last 4 digits"
    disabled={submitting}
    fieldProps={{
      parse: (value: string) => onlyNCharacters(4)(onlyNumbers(value)),
    }}
  />
);

export const renderAmountField = (submitting: boolean) => (
  <AmountInput name="amount" label="Amount" disabled={submitting} />
);

export const renderNarrationField = (submitting: boolean) => (
  <Input name="narration" label="Narration" disabled={submitting} />
);

export const renderPhoneNumberField = () => <Input name="phoneNumber" label="Phone Number" disabled />;

export const renderCardNameField = () => <Input name="cardName" label="Card Name" disabled />;

export const renderSingleCardLoadFields = (
  values: IFormValues,
  state: ICardsState,
  accounts: IAccount[],
  form: FormType,
  submitting: boolean,
  handleFieldsChange: IHandleFieldsChange,
) => (
  <>
    {renderSourceAccountField(accounts, submitting)}
    {renderCustomerIdField(values, state.beneficiaries, form, submitting, handleFieldsChange)}
    {renderPhoneNumberField()}
    {renderCardNameField()}
    {renderCardsLastFourDigitsField(submitting)}
    {renderAmountField(submitting)}
    {renderNarrationField(submitting)}
  </>
);
